import { render, staticRenderFns } from "./done.vue?vue&type=template&id=630baa56&scoped=true"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"
import style0 from "./done.vue?vue&type=style&index=0&id=630baa56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630baa56",
  null
  
)

export default component.exports